export default function pakt21ApiUrl(configuredApiUrl, path = '') {
  const currentOrigin = window.location.origin;
  const configuredUrl = new URL(configuredApiUrl, currentOrigin);
  const apiPath = configuredUrl.pathname.replace(/\/$/, '');
  const resourcePath = path === '' || path.startsWith('/') ? path : `/${path}`;

  return `${currentOrigin}${apiPath}${resourcePath}`;
}
